import './employeeStatistic.scss'
import 'chart.js';
import {
    DRAW_CHART_SERVICE_NAME,
    STATISTIC_SERVICE_NAME,
    ToastNotificationServiceName
} from "../../utils/names/serviceNames";
import {STATISTICS_TYPES_HOLDER, StatisticsType} from "../consts/StatisticsTypes";
import {
    ConversionLogTableDialog
} from "../../conversion_log/dialog/conversion-log-table.dialog/conversion-log-table.dialog.component";
import {StatisticsService} from "../service/statisticsService";
import {DrawChartService} from "../service/DrawChartService";
import {ToastNotificationService} from "../../utils/ToastNotificationService";
import {IScope} from "angular";
import {ChartData} from "chart.js";
import {OpportunityStatisticsBuilder} from "../builders/opportunity-statistics.builder";
import {OpportunityStatistics} from "../model/OpportunityStatistics";
import {ConversionStatisticsType} from "../model/ConversionStatisticsType";
import {StatisticPageParams} from "../model/StatisticPageParams";
import {CalculatorName} from "../../calculations/model/Calculator";
import {CampaignType} from "../../campaigns_service/model/CampaignType";

const CHART_ID = "CHART";
const datePattern = 'M/d/y';

type DateDescriptor = string | number | Date;

class DatePocket {
    public start: Date;
    public end: Date;

    constructor(start: DateDescriptor, end: DateDescriptor) {
        this.start = new Date(start);
        this.start.setHours(0, 0, 0, 0);
        this.end = new Date(end);
        this.end.setHours(23, 59, 59);
    }

    public matches(start: DateDescriptor, end: DateDescriptor): boolean {
        let compareStart = new Date(start);
        compareStart.setHours(23, 59, 59, 999);
        let compareEnd = new Date(end);
        compareEnd.setHours(0, 0, 0, 0);
        return compareStart >= this.start && compareEnd <= this.end;
    };

    public matchDate(date): boolean {
        return date >= this.start && date <= this.end;
    }
}

function convertToDate(dateString) {
    let isoDateString = new Date(dateString).toISOString();
    return isoDateString.substring(0, isoDateString.indexOf("T"));
}

interface Scope extends IScope {
    startDate: Date;
    endDate: Date;
    statisticsTypes: typeof STATISTICS_TYPES_HOLDER.enum;
    statisticType: StatisticsType;
    aggregateN: number;
    showConfiguration: boolean;
    updateChartType: () => void;
}

export class EmployeeStatistic {
    private chartCtx: any;
    private $scope: Scope;
    private statisticService: StatisticsService;
    private $filter: any;
    private $mdDialog: angular.material.IDialogService;
    private toastNotificationService: ToastNotificationService;
    private lineChartSevice: DrawChartService;

    private aggregateN: number;
    private pockets: DatePocket[];
    private chart: any;

    constructor($scope,
                $filter,
                private $location : ng.ILocationService,
                $mdDialog,
                statisticService,
                lineChartService,
                toastNotificationService) {
        // @ts-ignore
        this.chartCtx = document.getElementById(CHART_ID).getContext('2d');
        this.$scope = $scope;
        this.$scope.startDate = new Date();
        this.$scope.endDate = new Date();
        this.$scope.statisticsTypes = STATISTICS_TYPES_HOLDER.enum;
        this.$scope.startDate.setDate(new Date().getDate() - 7);
        this.$scope.statisticType = StatisticsType.NUMBER_OF_CUSTOMERS;
        this.statisticService = statisticService;
        this.$filter = $filter;
        this.$mdDialog = $mdDialog;
        this.toastNotificationService = toastNotificationService;
        this.lineChartSevice = lineChartService;
        this.$scope.aggregateN = 1;
        this.$scope.updateChartType = this.updateChartType;
    }

    $onInit() {
        this.updateFromUrlParams();
        this.bindUrlParameters();
        this.updateChartType();
    }


    private bindUrlParameters() {
        this.$scope.$on('$locationChangeSuccess', this.updateFromUrlParams);
        this.$scope.$watch('startDate', this.updateUrlParams, true);
        this.$scope.$watch('endDate', this.updateUrlParams, true);
        this.$scope.$watch('aggregateN', this.updateUrlParams);
        this.$scope.$watch('statisticType', this.updateUrlParams);
    }

    private updateFromUrlParams = () => {
        let search = <StatisticPageParams>this.$location.search();
        if (search.aggregateN == undefined) {
            return;
        }
        this.$scope.startDate = new Date(search.startDate);
        this.$scope.endDate = new Date(search.endDate);
        this.$scope.aggregateN = parseInt(search.aggregateN);
        this.$scope.statisticType = StatisticsType[search.statisticType];
    };

    private updateUrlParams = () => {
        this.$location.search('startDate', this.getFormattedDate(this.$scope.startDate));
        this.$location.search('endDate', this.getFormattedDate(this.$scope.endDate));
        this.$location.search('aggregateN', this.$scope.aggregateN);
        this.$location.search('statisticType', this.$scope.statisticType);
    }

    updateChartType = () => {
        this.updateAggregation();
        this.updateDatePockets();
        this.updateShowConfiguration();
        switch (this.$scope.statisticType) {
            case StatisticsType.NUMBER_OF_CUSTOMERS:
                this.drawNumberOfNewCustomersChart();
                break;
            case StatisticsType.TOTAL_CUSTOMERS:
                this.drawTotalNumberOfCustomersChart();
                break;
            case StatisticsType.OPPORTUNITIES:
                this.drawOpportunitiesStatistics();
                break;
            case StatisticsType.OPPORTUNITY_ACTIONS:
                this.drawActionsStatistics();
                break;
            case StatisticsType.CONVERSION:
                this.drawConversionStatistics();
                break;
            case StatisticsType.CONVERSION_BY_CALCULATOR_NAME:
                this.drawConversionByCalculatorStatistics();
                break;
            case StatisticsType.CONVERSION_BY_CAMPAIGN_TYPE:
                this.drawConversionByCampaignStatistics();
                break;

        }
    };

    private updateShowConfiguration = () => {
        let activeEnum = STATISTICS_TYPES_HOLDER.findByValue(this.$scope.statisticType);
        this.$scope.showConfiguration = activeEnum.dateLimits;
    };

    private updateAggregation = () => {
        if (this.$scope.aggregateN == null || this.$scope.aggregateN <= 0) {
            this.aggregateN = 1;
        } else {
            this.aggregateN = this.$scope.aggregateN;
        }
    };


    updateDatePockets = () => {
        let duration = +this.aggregateN;
        let pockets = [];
        let start = new Date(this.$scope.startDate);
        pockets.push(this.getNextPocket(start, duration));
        let end = pockets[pockets.length - 1].end;
        while (end < this.$scope.endDate) {
            end = pockets[pockets.length - 1].end;
            pockets.push(this.getNextPocket(end, duration));
        }
        this.pockets = pockets;
    };

    drawOpportunitiesStatistics() {
        let startDate = this.$scope.startDate;
        let endDate = this.$scope.endDate;
        return this.statisticService.getOpportunitiesStatistics(
            convertToDate(startDate),
            convertToDate(endDate),
            this.$scope.aggregateN
        ).then(resp => {
            if (resp.status === 200) {
                this.drawOpportunitiesChart(resp.data, startDate, endDate);
            } else {
                this.toastNotificationService.generateErrorMessage('Failed to fetch opportunities statistics data')
            }
        }, (err) => {
            throw err;
        });
    }

    getNumberOfNewCustomersData(): angular.IPromise<Chart.ChartData> {
        return this.statisticService.getNumberOfCustomers(
            convertToDate(this.$scope.startDate),
            convertToDate(this.$scope.endDate),
            this.aggregateN,
            this.pockets,
            'api/statistic/customers')
            .then(resp => resp.data);
    }

    getTotalNumberOfCustomersData(): angular.IPromise<Chart.ChartData> {
        return this.statisticService.getNumberOfCustomers(
            convertToDate(this.$scope.startDate),
            convertToDate(this.$scope.endDate),
            this.aggregateN,
            this.pockets,
            'api/statistic/customers/total')
            .then((resp) => resp.data);
    }


    assignCountsToGoroup(groups) {
        let counts = this.pockets.map(() => 0);
        this.pockets.forEach((pocket, i) => {
            groups.forEach((d, j) => {
                if (pocket.matches(d.start, d.end)) {
                    counts[i] += d.count;
                    delete groups[j];
                }
            });
        });
        return counts;
    }

    private drawOpportunitiesChart(statistics: OpportunityStatistics[],
                                   startDate: Date,
                                   endDate: Date) {
        let builder = new OpportunityStatisticsBuilder(statistics);
        let dataset = builder.buildForDates(startDate, endDate);
        this.drawStackedBarGraph(`Opportunities ${this.getPeriodSubtitle()}`, dataset);
    }

    private drawActionsStatistics = () => {
        this.statisticService.getOpportunityActionStatistics(
            convertToDate(this.$scope.startDate),
            convertToDate(this.$scope.endDate),
            this.aggregateN
        ).then(staistics => {
            this.drawActionsStatisticsChart(
                staistics.data,
                this.$scope.startDate,
                this.$scope.endDate
            );
        })
    };

    private drawActionsStatisticsChart = (statistics: OpportunityStatistics[], startDate: Date, endDate: Date) => {
        let builder = new OpportunityStatisticsBuilder(statistics);
        let dataset = builder.buildForDates(startDate, endDate);
        this.drawStackedBarGraph(`Opportunity Actions ${this.getPeriodSubtitle()}`, dataset);
    };

    drawTotalNumberOfCustomersChart() {
        this.getTotalNumberOfCustomersData()
            .then(data => this.drawLineChart(data, 'Total number of customer'))

    }

    drawNumberOfNewCustomersChart() {
        this.getNumberOfNewCustomersData()
            .then(data => this.drawLineChart(data, 'Number of new customers'));
    }

    drawConversionStatistics() {
        this.drawConversionStatisticsOfType(ConversionStatisticsType.CONVERSION_TYPE);
    }

    drawConversionByCalculatorStatistics() {
        this.drawConversionStatisticsOfType(ConversionStatisticsType.CALCULATOR_NAME);
    }

    drawConversionByCampaignStatistics() {
        this.drawConversionStatisticsOfType(ConversionStatisticsType.CAMPAIGN_TYPE);
    }

    drawConversionStatisticsOfType(type: ConversionStatisticsType) {
        let startDate = this.$scope.startDate;
        let endDate = this.$scope.endDate;
        this.statisticService.getConversionsStatistics(
            convertToDate(startDate),
            convertToDate(endDate),
            this.aggregateN,
            this.pockets.length,
            type
        ).then(resp => {
            if (resp.status === 200) {
                this.drawConversionsChart(resp.data, type);
            } else {
                this.toastNotificationService.generateErrorMessage('Failed to fetch conversions statistics data')
            }
        }, (err) => {
            throw err;
        });
    }

    drawConversionsChart(data: ChartData, type: ConversionStatisticsType) {
        this.drawLineChart(data, 'Number of conversions', (event, elements) => {
            if (elements.length > 0) {
                let filter = {
                    branchNames: [],
                    brandName: [],
                    conversionTypes: [],
                    campaignTypes: this.getCampaignTypes(type),
                    calculatorNames: this.getCalculatorNames(type),
                    startDate: this.$scope.startDate,
                    endDate: this.$scope.endDate
                };
                this.$mdDialog.show(ConversionLogTableDialog.instance(filter))
            }
        })
    }

    getCampaignTypes(type: ConversionStatisticsType): CampaignType[] {
        switch (type) {
            case ConversionStatisticsType.CALCULATOR_NAME:
                return [];
            default:
                return Object.values(CampaignType);
        }
    }

    getCalculatorNames(type: ConversionStatisticsType): CalculatorName[] {
        switch (type) {
            case ConversionStatisticsType.CAMPAIGN_TYPE:
                return [];
            default:
                return Object.values(CalculatorName);
        }
    }

    getNextPocket(start: Date, duration: number) {
        let newEnd = new Date(start);
        newEnd.setDate(start.getDate() + duration);
        newEnd.setHours(0, 0, 0, 0);
        return new DatePocket(new Date(start), new Date(newEnd));
    }

    getPeriodSubtitle() {
        return `From ${this.getShortDate(this.$scope.startDate)} to ${this.getShortDate(this.$scope.endDate)}`;
    }

    getShortDate(date) {
        return this.$filter('date')(date, datePattern);
    }

    drawStackedBarGraph(title, data: ChartData) {
        if (this.chart) this.chart.destroy();
        this.chart = this.lineChartSevice.drawStackedBarGraph(this.chartCtx, title, data)
    }

    drawLineChart(data: ChartData, title: string, callback?) {
        if (this.chart) this.chart.destroy();
        this.chart = this.lineChartSevice.drawLineChart(this.chartCtx, data, title, callback);
    }

    getFormattedDate(date) {
        return this.$filter('date')(date, datePattern);
    }
}

export const EMPLOYEE_STATISTIC_COMPONENT = {
    controller: ['$scope', '$filter', '$location', '$mdDialog', STATISTIC_SERVICE_NAME, DRAW_CHART_SERVICE_NAME, ToastNotificationServiceName, EmployeeStatistic],
    template: require('./employeeStatistic.html'),
    bindings: {
        'employee': '<'
    }
};